import Vue from 'vue';
import Router from 'vue-router';
import Index from './views/Index.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'index',
            component: Index,
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
        },
        {
            path: '/product',
            name: 'product',
            component: () => import(/* webpackChunkName: "about" */ './views/Product.vue'),
        },
        {
            path: '/news',
            name: 'news',
            component: () => import(/* webpackChunkName: "about" */ './views/News.vue'),
        },
        {
            path: '/news/:id',
            name: 'news-detail',
            component: () => import(/* webpackChunkName: "about" */ './views/NewsDetail.vue'),
        },
        {
            path: '/join',
            name: 'join',
            component: () => import(/* webpackChunkName: "about" */ './views/Join.vue'),
        }, {
            path: '/teachers-info',
            name: 'teachers-info',
            component: () => import('./views/TeachersInfo.vue')
        }, {
            path: '/contract',
            name: 'contract',
            component: () => import('./views/Contract.vue')
        }
    ],
});
